export default {
  default: {
    title: 'No Agreements Available.',
    paragraph: 'There are no agreements available in this project yet. You can create one now using the button at the top of the page.',
  },
}
